import { TStorePaths } from '@/common/types/storePaths';

export const EVENTS_VES = 'eventsVES';

export const EVENTS_VES_ACTIONS_NAME = {
  getEventsTable: `${EVENTS_VES}/getEventsTable`,
  getIndicatorCards: `${EVENTS_VES}/getIndicatorCards`,
  createEvent: `${EVENTS_VES}/createEvent`,
  updateEvent: `${EVENTS_VES}/updateEvent`,
  deleteEvent: `${EVENTS_VES}/deleteEvent`,
  getEventById: `${EVENTS_VES}/getEventById`,
  getMinistryEventsTable: `${EVENTS_VES}/getMinistryEventsTable`,
};

export const EVENTS_VES_MUTATIONS_NAME = {
  setEvents: `${EVENTS_VES}/setEvents`,
  setEventsTable: `${EVENTS_VES}/setEventsTable`,
  setMinistryEventsTable: `${EVENTS_VES}/setMinistryEventsTable`,
  setIndicatorCards: `${EVENTS_VES}/setIndicatorCards`,
};

export const EVENTS_VES_GETTERS_NAME = {
  getListOfEvents: `${EVENTS_VES}/getListOfEvents`,
  getEventsTable: `${EVENTS_VES}/getEventsTable`,
  getMinistryEventsTable: `${EVENTS_VES}/getMinistryEventsTable`,
  getIndicatorCards: `${EVENTS_VES}/getIndicatorCards`,
};

export const MINISTRY_EVENTS_STORE_PATHS: TStorePaths = {
  action: EVENTS_VES_ACTIONS_NAME.getMinistryEventsTable,
  mutation: EVENTS_VES_MUTATIONS_NAME.setMinistryEventsTable,
  getter: EVENTS_VES_GETTERS_NAME.getMinistryEventsTable,
};
